module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ki-Lb.d70969b7.png";